import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { getDisplayedPrice } from "../../engine/PriceUtilities";
import DataPanel from "../DataPanel";
import ShapeDetails from "./ShapeDetails";
import ShapesCleanupButton from "./ShapesCleanupButton";

interface Props {
  readonly customerId: number;
  readonly priceListId: number;
}

const columns = [
  {
    name: 'name',
    label: 'Nazwa',
  },
  {
    name: 'material',
    label: 'Materiał',
  },
  {
    name: 'unitPrice',
    label: 'Cena (jednostkowa)',
  },
  {
    name: 'block',
    label: 'Bryła (całkowita)',
  },
  {
    name: 'unitQuantity',
    label: 'Ilość',
  },
  {
    name: 'unitWeight',
    label: 'Waga (jednostkowa)',
  }
];

const ShapesPanel = (props: Props) => {
  const customerId = props.customerId;
  const priceListId = props.priceListId;

  const renderCustomShapesButtons = (
    buttonClasses: ClassNameMap,
    getSelectedIds: () => number[],
    fetchData: () => void,
    reportAlerts: (messages: string[]) => void
  ) => {
    return <ShapesCleanupButton
      buttonClasses={ buttonClasses }
      customerId={ customerId }
      priceListId={ priceListId }
      reportAlerts={ reportAlerts }
      refreshShapes={ fetchData }
    />
  };

  return <>
    <DataPanel
      title='Wykroje'
      resource={`customers/${customerId}/price-lists/${priceListId}/shapes`}
      columns={columns}
      deleteRequiresConfirmation
      tableSearchEnabled
      renderDetails={(detailsProps) => <ShapeDetails { ...{ ...detailsProps, customerId, priceListId }} />}
      renderCustomButtons={ renderCustomShapesButtons }
      convert={(data: any) => ({
        ...data,
        material: data.material.name,
        unitPrice: getDisplayedPrice(data.unitPrice),
        block: `${data.block.length} x ${data.block.width} x ${data.block.depth}`
      })}
    />
  </>;
};
export default ShapesPanel;